import { Card, CardContent, Container, Grid, Typography } from '@mui/material';
import React from 'react';

const Faq = () => {
  const faqs = [
    {
      question: "What differentiates RentFinder.ai from previous rental estimation tools?",
      answer: "RentFinder.ai advances rental market intelligence by utilizing intricate AI analytics across extensive data sets for exact rent estimates and comprehensive market reviews. It's your go-to investment tool designed to equip rental investors and managers with reliable insights for optimal investment decisions."
    },
    {
      question: "How does RentFinder.ai ensure highly accurate rent estimates?",
      answer: "By adopting a diverse array of data sources and employing advanced AI analysis, RentFinder.ai offers unparalleled precision in market rent calculations. The accuracy is fortified by confidence scores that outdo competing platforms. Trust in rental pricing has never been this solid with our extensively tested data."
    },
    {
      question: "Is RentFinder.ai capable of adjusting its analysis to my specific rental property criteria?",
      answer: "Absolutely! RentFinder.ai is prepared for real-time, conversational AI analysis that adapts its insights and suggestions to your unique property metrics. This offers you the ability to simulate alternate scenarios for a more custom-tailored investment strategy."
    },
    {
      question: 'What data sources does RentFinder.ai employ to estimate rental values?',
      answer: "We use a comprehensive proprietary range of data points from extensive US sources, guaranteeing robust and reliable rental valuation that identifies crucial details overlooked by typical rent predictor tools. The extensive data diversity intensifies your confidence in setting optimal rent rates for any U.S. property."
    },
    {
      question: 'Is my data secure with RentFinder.ai? How is privacy maintained?',
      answer: 'Your data integrity is our top priority. RentFinder.ai adheres to robust security measures ensuring your search history remains confidential and will never be sold, shared, or used for competing purposes. See our Privacy Policy for more details.'
    },
    {
      question: 'How does RentFinder.ai\'s AI-driven precision offer advantages in rental investing?',
      answer: 'The advanced AI analysis of RentFinder.ai delves deep into extensive market trends and intricate property specifics, providing actionable insights that align with higher rental incomes and lower vacancy periods. Drive profitable, low-risk decisions that significantly improve portfolio performance with the aid of RentFinder.ai.'
    },
    {
      question: 'How can RentFinder.ai aid in reducing property vacancies?',
      answer: 'Armed with precise rent rate assessments and comprehensive market analysis, RentFinder.ai empowers you to optimize your rental pricing strategy. This attracts reliable tenants in quicker succession while reducing vacancy rates.'
    },
    {
      question: 'What kind of reports and analysis can I expect with a RentFinder.ai subscription?',
      answer: 'Enjoy interactive, crystal-clear property reports that offer detailed analytics. The diverse format of reports available ensures informed decision-making processes, presenting a well-rounded view of the rental landscape.'
    },
    {
      question: 'Are there different subscription plans available? Do I need to keep track of report counts or credits?',
      answer: 'RentFinder.ai offers a convenient flat-rate monthly subscription or allows users to pre-purchase a set amount of reports, allowing straightforward budgeting without any hidden charges or fluctuating costs. No more tracking usage. For high-volume users or special needs, please contact us for bespoke bulk/API pricing options.'
    }
  ]

  return (
    <Container>
      <Typography variant="h4" component="h1" gutterBottom>
        Frequently Asked Questions
      </Typography>
      <Grid container spacing={3} sx={{ textAlign: 'left' }}>
        {faqs.map((faq, index) => (
          <Grid item xs={12} key={index}>
            <Card sx={{ width: '100%' }}>
              <CardContent>
                <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                  <strong>{faq.question}</strong>
                </Typography>
                <Typography variant="body1">
                  {faq.answer}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
};

export default Faq;